/* eslint-disable no-undef */
import React, { useState } from 'react';
import { Styles } from './style';
import { useNavigate } from 'react-router-dom';
import { addFormData } from './dataTest';
import AuthenticatedLayout from '@screens/Authenticated/Layout/Layout';
import { useMediaQuery, useTheme } from '@mui/material';

interface FormData {
  cod: string;
  title: string;
  id: string;
}

const NewCodeScreen: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const [formData, setFormData] = useState<FormData>({
    cod: '',
    title: '',
    id: ''
  });

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    addFormData(formData);
    console.log('Dados do formulário salvos:', formData);
    navigate(-1);
  };
  return (
    <AuthenticatedLayout>
      <h1>CADASTRO DE NOVO CÓDIGO DE IMÓVEL</h1>
      <Styles.RectangleBar />
      <form onSubmit={handleSubmit}>
        <Styles.FlexRow $isMobile={isMobile}>
          <Styles.FormFieldContainer>
            <Styles.FormLabel htmlFor="cod">Código do Imóvel</Styles.FormLabel>
            <Styles.FormInput
              type="text"
              id="cod"
              name="cod"
              value={formData.cod}
              onChange={handleChange}
              style={{
                width: isMobile ? '100%' : '120px'
              }}
            />
          </Styles.FormFieldContainer>

          <Styles.FormFieldContainer>
            <Styles.FormLabel htmlFor="title">Título</Styles.FormLabel>
            <Styles.FormInput
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              style={{
                width: isMobile ? '100%' : '500px'
              }}
            />
          </Styles.FormFieldContainer>

          <Styles.FormFieldContainer>
            <Styles.FormLabel htmlFor="id">ID</Styles.FormLabel>
            <Styles.FormInput
              type="text"
              id="id"
              name="id"
              value={formData.id}
              onChange={handleChange}
              style={{
                width: isMobile ? '100%' : '90px'
              }}
            />
          </Styles.FormFieldContainer>
        </Styles.FlexRow>
        <Styles.CardButtons>
          <Styles.ViewButton type="submit">Enviar</Styles.ViewButton>
          <Styles.EditButton type="button" onClick={() => navigate(-1)}>
            Cancelar
          </Styles.EditButton>
        </Styles.CardButtons>
      </form>
    </AuthenticatedLayout>
  );
};

export default NewCodeScreen;
